/*
 * Copyright (c) 2023
 *
 * The source code and all documents related to the source code ("Material") are owned by
 * Frictionless Systems, LLC.
 *
 * The Material contains trade secrets, proprietary information, and confidential information.
 * No part of the Material may be used, copied, reproduced, modified, published, distributed, or
 * disclosed in any way without Frictionless Systems, LLC’s express prior written permission.
 *
 * The Material may be protected under patent, trademark, copyright, or trade secret laws.  No
 * license is granted to you by disclosure or delivery of the Materials.  Any license must be
 * express and approved by Frictionless Systems, LLC in writing.
 *
 * “Frictionless Systems” and “Impulse” are registered trademarks of Frictionless Systems, LLC.
 */

package systems.frictionless.impulse.browser.style

import org.jetbrains.compose.web.css.CSSUnitValue
import org.jetbrains.compose.web.css.variable

object AppStyleSheetVariables {
    val fontSizeNormal by variable<CSSUnitValue>()
    val fontSizeSmall by variable<CSSUnitValue>()
    val fontSizeBigger by variable<CSSUnitValue>()
    val fontSizeHeader by variable<CSSUnitValue>()
    val fontSizeTextAreaPlaceholder by variable<CSSUnitValue>()
    val fontSizeQuestionText by variable<CSSUnitValue>()
    val fontSizeQuestionHintText by variable<CSSUnitValue>()
    val fontSizeLoginFormHeader by variable<CSSUnitValue>()
    val fontSizeTextArea by variable<CSSUnitValue>()

    val elementWidthLarge by variable<CSSUnitValue>()
    val elementWidthMedium by variable<CSSUnitValue>()
    val elementWidthSmall by variable<CSSUnitValue>()
}
